module.exports = __webpack_public_path__ + "static/what-is-mining-f4d1f2e1ad3d4366e9ef97ab1a9d95c3.svg";